import cn from "classnames"
import * as Icons from "@nova/component-icons"
import { Dropdown } from "@nova/component-dropdown"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectWeatherTimeline } from "features/map/control/selectors"
import { setWeatherPlaybackSpeed } from "features/map/control/slice"

const PLAYBACK_SPEEDS = [2, 1.5, 1, 0.5] as const

type Props = { isLight: boolean }

export const SelectPlaybackSpeed = ({ isLight }: Props) => {
    const dispatch = useAppDispatch()
    const { playbackSpeed } = useAppSelector(selectWeatherTimeline)

    const mutedColor = isLight ? "text-gray-500" : "text-gray-400"

    return (
        <Dropdown>
            <Dropdown.Trigger
                as="button"
                className="group flex w-fit items-center gap-1 bg-transparent text-left"
            >
                <span className={cn("text-xs leading-none tabular-nums", mutedColor)}>
                    Speed ({playbackSpeed}x)
                </span>
                <Icons.ArrowDropUp className={cn("group-aria-expanded:hidden", mutedColor)} />
                <Icons.ArrowDropdown
                    className={cn("hidden group-aria-expanded:block", mutedColor)}
                />
            </Dropdown.Trigger>
            <Dropdown.Menu
                unstyled
                position="top-left"
                className="w-[128px] rounded-xl bg-gray-900 p-2 shadow-lg"
            >
                <div className="flex flex-col">
                    {PLAYBACK_SPEEDS.map((speed) => (
                        <Dropdown.ButtonItem
                            key={speed}
                            type="button"
                            onClick={() => dispatch(setWeatherPlaybackSpeed(speed))}
                            className={cn(
                                "rounded-lg px-3 py-2 text-left text-sm font-normal leading-[140%] hover:bg-white-100",
                                speed === playbackSpeed ? "text-gray-0" : "text-gray-400"
                            )}
                        >
                            {speed}x
                        </Dropdown.ButtonItem>
                    ))}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}
